import React from 'react';
import './style.scss';

const Block = ({ children }) => <div className="block">{children}</div>;

export default Block;
export { Block };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/block/index.js